import { render, staticRenderFns } from "./label_index.html?vue&type=template&id=ac9fe250&scoped=true&external"
import script from "./label_index.vue?vue&type=script&lang=js"
export * from "./label_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9fe250",
  null
  
)

export default component.exports